import { IAjaxBaseState, ajaxBaseState } from 'flux-entities'

import { TSSORealm } from '../../types/ssoRealm'

export interface ISSORealmsState extends IAjaxBaseState<TSSORealm> {
}

const createInitialSSORealmsState = (): ISSORealmsState => {
  return {
    ...ajaxBaseState()
  }
}

export {
  createInitialSSORealmsState
}
